import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Loader } from "../../components/CustomLoader";
import { userServices } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import { capitalize } from "../../utils/helpers";

const ViewUserManagement = ({ id, show, onHide }) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);

  const userData = async () => {
    try {
      setLoading(true);
      const response = await userServices.getById({ id: id });
      setData(response.data.data);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    userData();
  }, [id]);

  return (
    <Dialog maxWidth="md" fullWidth={true} open={show} onClose={onHide}>
      <DialogTitle as="h2">User Details</DialogTitle>
      {loading ? (
        <Loader />
      ) : (
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="subtitle1">Full Name</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {capitalize(data?.name)}
              </DialogContentText>
            </Grid>

            <Grid item xs={6} md={6}>
              <Typography variant="subtitle1">Email</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {data?.email}
              </DialogContentText>
            </Grid>

            {data?.phoneNumber && (
              <Grid item xs={6} md={6}>
                <Typography variant="subtitle1">Phone Number</Typography>
                <DialogContentText sx={{ marginBlockStart: "1em" }}>
                  {data?.phoneNumber}
                </DialogContentText>
              </Grid>
            )}

            {data?.address && (
              <Grid item xs={6} md={6}>
                <Typography variant="subtitle1">Address</Typography>
                <DialogContentText sx={{ marginBlockStart: "1em" }}>
                  {capitalize(data?.address)}
                </DialogContentText>
              </Grid>
            )}

            <Grid item xs={6} md={6}>
              <Typography variant="subtitle1">Bid Wallet Balance</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {data?.totalBids?.toFixed(0)} Bids
              </DialogContentText>
            </Grid>

            <Grid item xs={6} md={6}>
              <Typography variant="subtitle1">Refer Code</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {data?.referralCode}
              </DialogContentText>
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography variant="subtitle1">Status</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {capitalize(data?.status)}
              </DialogContentText>
            </Grid>

          </Grid>
          <DialogActions>
            <Button variant="outlined" onClick={onHide} type="button">
              Close
            </Button>
          </DialogActions>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default ViewUserManagement;